(function ($) {
    function setBannerTransparentStylesForFeaturedItem() {
        if (!$('.component').closest('.tab_component').length) {  // Check if the parent doesn't have the 'tab_component' class
            $('.component').each(function () {
                if ($(this).hasClass('f01-featured-item') == true) {
                    if (($(this).find('.featured-item-slide-title-copy').length > 0) && (($(this).find('.featured-item-slide-title-copy').attr('data-opacity')) != undefined)) {
                        $(this).find('.featured-item-slide-title-copy').css('opacity', 'unset');
                        var opacity3 = ((($(this).find('.featured-item-slide-title-copy').attr('data-opacity')) != '') && (($(this).find('.featured-item-slide-title-copy').attr('data-opacity')) != ' ')) ? (parseFloat($(this).find('.featured-item-slide-title-copy').attr('data-opacity'))) : 1;
                        $(this).find('.featured-item-slide-title-copy').css('background', 'rgba(255,255,255,' + opacity3 + ')');
                    }
                    else if (($(this).find('.featured-item-title').length > 0) && (($(this).find('.featured-item-title').attr('data-opacity')) != undefined) && ($(this).find('.featured-item-title').parent().hasClass('featured-item-copy-inner') == false)) {
                        $(this).find('.featured-item-title').css('opacity', 'unset');
                        var opacity4 = ((($(this).find('.featured-item-title').attr('data-opacity')) != '') && (($(this).find('.featured-item-title').attr('data-opacity')) != ' ')) ? (parseFloat($(this).find('.featured-item-title').attr('data-opacity'))) : 1;
                        $(this).find('.featured-item-title').css('background', 'rgba(255,255,255,' + opacity4 + ')');
                    }
                    else {
                        if (($(this).find('.featured-item-slide-title-copy').length > 0) && (($(this).find('.featured-item-slide-title-copy').attr('data-opacity')) == undefined)) {
                            $(this).find('.featured-item-slide-title-copy').css('opacity', 'unset');
                            $(this).find('.featured-item-slide-title-copy').css('background', 'rgba(255,255,255,1)');
                        }
                        if (($(this).find('.featured-item-title').length > 0) && (($(this).find('.featured-item-title').attr('data-opacity')) == undefined) && ($(this).find('.featured-item-title').parent().hasClass('featured-item-copy-inner') == false)) {
                            $(this).find('.featured-item-title').css('opacity', 'unset');
                            $(this).find('.featured-item-title').css('background', 'rgba(255,255,255,1)');
                        }
                    }
                }
            });
        }
    }
    $(document).ready(function () {
        setBannerTransparentStylesForFeaturedItem();

        $('div.component.f01-featured-item').on('keydown', function (e) { //?
            if ((e.keyCode === 13 || e.keyCode === 32)) {
                if ($(this).find("a.btn.btn-primary").length)
                    $(this).find("a.btn.btn-primary")[0].click();
            }
        });
    });
}(window.jQuery));

function initalLoadComplete() {
    var listOfFeatureItem = $(".featured-item-slide-title-copy");
    for (var i = 0; i < listOfFeatureItem.length; i++) {
        if ($(listOfFeatureItem[i]).text().trim() === "") {
            $(listOfFeatureItem[i]).hide();
        }
    }
}
$(window).on("load", initalLoadComplete);

/*Analytics*/
analytics.eventConfig.push( // Featured Item F0
    {
        "target": ".component.f01-featured-item",
        "codeId": "f0",
        "events": [
            {
                "eventTarget": ".featured-item-cta > a[href*=\\http], .featured-item-copy-inner > a[href*=\\http], .featured-title-copy > a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "f0",
                    "componentName": "featured item1",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).parent('button').length > 0 || $(context).hasClass('btn')",
                            "value": "featured item button"
                        },
                        {
                            "rule": "true",
                            "value": "featured item link"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".featured-item-cta > a:not([href*=\\http]), .featured-item-copy-inner > a:not([href*=\\http]), .featured-title-copy > a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "f0",
                    "componentName": "featured item",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).parent('button').length > 0 || $(context).hasClass('btn')",
                            "value": "featured item button"
                        },
                        {
                            "rule": "$(context).children('img').length > 0",
                            "value": "featured item image"
                        },
                        {
                            "rule": "true",
                            "value": "featured item link"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "featured item internal navigation click"
                        }
                    ],
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": "a[href*=\\http].btn.btn-secondary.expanding-box-trigger",
                "eventType": "click",
                "tags": {
                    "componentId": "f0",
                    "componentName": "featured item",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "featured item button",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": "a:not([href*=\\http]).btn.btn-secondary.expanding-box-trigger",
                "eventType": "click",
                "tags": {
                    "componentId": "f0",
                    "componentName": "featured item",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "featured item button",

                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "featured item internal navigation click"
                        }
                    ],
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }

        ]
    });